// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpressSetupJson } from './IExpressSetupJson';
import {
    IExpressSetupJsonFromJSON,
    IExpressSetupJsonFromJSONTyped,
    IExpressSetupJsonToJSON,
    IExpressSetupJsonToJSONTyped,
} from './IExpressSetupJson';
import type { IContactDto } from './IContactDto';
import {
    IContactDtoFromJSON,
    IContactDtoFromJSONTyped,
    IContactDtoToJSON,
    IContactDtoToJSONTyped,
} from './IContactDto';
import type { IExpressSetupLinkDto } from './IExpressSetupLinkDto';
import {
    IExpressSetupLinkDtoFromJSON,
    IExpressSetupLinkDtoFromJSONTyped,
    IExpressSetupLinkDtoToJSON,
    IExpressSetupLinkDtoToJSONTyped,
} from './IExpressSetupLinkDto';
import type { IAuditActor } from './IAuditActor';
import {
    IAuditActorFromJSON,
    IAuditActorFromJSONTyped,
    IAuditActorToJSON,
    IAuditActorToJSONTyped,
} from './IAuditActor';

/**
 * 
 * @export
 * @interface IExpressSetupDto
 */
export interface IExpressSetupDto {
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupDto
     */
    org_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupDto
     */
    org_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupDto
     */
    tax_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupDto
     */
    organization_short_name?: string;
    /**
     * 
     * @type {IExpressSetupLinkDto}
     * @memberof IExpressSetupDto
     */
    links?: IExpressSetupLinkDto;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupDto
     */
    contact_id?: number;
    /**
     * 
     * @type {Array<IContactDto>}
     * @memberof IExpressSetupDto
     */
    contacts?: Array<IContactDto>;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupDto
     */
    status_type?: IExpressSetupDtoStatusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupDto
     */
    is_external_link?: boolean;
    /**
     * 
     * @type {IExpressSetupJson}
     * @memberof IExpressSetupDto
     */
    json_record?: IExpressSetupJson;
    /**
     * 
     * @type {IAuditActor}
     * @memberof IExpressSetupDto
     */
    audit_actor?: IAuditActor;
}

/**
* @export
* @enum {string}
*/
export enum IExpressSetupDtoStatusTypeEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    ABANDONED = 'ABANDONED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    ADVANCED_SETUP = 'ADVANCED_SETUP'
}


/**
 * Check if a given object implements the IExpressSetupDto interface.
 */
export function instanceOfIExpressSetupDto(value: object): value is IExpressSetupDto {
    return true;
}

export function IExpressSetupDtoFromJSON(json: any): IExpressSetupDto {
    return IExpressSetupDtoFromJSONTyped(json, false);
}

export function IExpressSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'organization_short_name': json['organization_short_name'] == null ? undefined : json['organization_short_name'],
        'links': json['links'] == null ? undefined : IExpressSetupLinkDtoFromJSON(json['links']),
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(IContactDtoFromJSON)),
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'is_external_link': json['is_external_link'] == null ? undefined : json['is_external_link'],
        'json_record': json['json_record'] == null ? undefined : IExpressSetupJsonFromJSON(json['json_record']),
        'audit_actor': json['audit_actor'] == null ? undefined : IAuditActorFromJSON(json['audit_actor']),
    };
}

export function IExpressSetupDtoToJSON(json: any): IExpressSetupDto {
    return IExpressSetupDtoToJSONTyped(json, false);
}

export function IExpressSetupDtoToJSONTyped(value?: IExpressSetupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'org_id': value['org_id'],
        'org_path': value['org_path'],
        'organization_name': value['organization_name'],
        'external_identifier': value['external_identifier'],
        'tax_id': value['tax_id'],
        'organization_short_name': value['organization_short_name'],
        'links': IExpressSetupLinkDtoToJSON(value['links']),
        'contact_id': value['contact_id'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(IContactDtoToJSON)),
        'status_type': value['status_type'],
        'is_external_link': value['is_external_link'],
        'json_record': IExpressSetupJsonToJSON(value['json_record']),
        'audit_actor': IAuditActorToJSON(value['audit_actor']),
    };
}

